import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'accent' | 'danger' | 'outline';
  className?: string;
}
const tones: Record<string, string> = {
  accent: 'border-accent/40 bg-accent/10 text-accent',
  danger: 'border-danger/40 bg-danger/10 text-danger',
  outline: 'border-line bg-panel text-muted'
};
export function Pill({
  children,
  tone = 'accent',
  className = ''
}: PillProps) {
  return <span className={`inline-flex items-center rounded-full border px-4 py-1 font-display text-sm font-semibold uppercase tracking-[0.16em] ${tones[tone]} ${className}`} data-id="element-166" data-mp="1aw3hmfz3cxoh">
      {children}
    </span>;
}